const architectureExamples = [
  {
    title: "Taj Mahal",
    description: "The great Monument of India, with its beautiful architecture is indeed based on the principles of golden ratio. Amazing right!",
    primaryImgSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Taj_Mahal%2C_Agra%2C_India_edit3.jpg/640px-Taj_Mahal%2C_Agra%2C_India_edit3.jpg",
    onClickImgSrc: "https://i1.wp.com/docelticjewelry.com/wp-content/uploads/2015/11/Taj-Mahal-Golden-Rectangle.png?ssl=1"
  },
  {
    title: "The Great Pyramids of Egypt",
    description: "The Great Pyramid has a base of 230.4 meters (755.9 feet) and an estimated original height of 146.5 meters (480.6 feet). This also creates a height to base ratio of 0.636, which indicates it is indeed a Golden Triangles, at least to within three significant decimal places of accuracy.",
    primaryImgSrc: "https://mymodernmet.com/wp/wp-content/uploads/2018/11/egyptian-pyramids-thumbnail.jpg",
    onClickImgSrc: "https://i.pinimg.com/originals/e9/36/34/e93634c0f0754adb0599392214d19fc5.jpg"
  },
  {
    title: "The Parthenon",
    description: "The Parthenon is an international symbol of Greek civilization and the temples of the Acropolis have become some of the world's most famous architectural landmarks.",
    primaryImgSrc: "https://cdn.hswstatic.com/gif/parthenon-golden-ratio-orig.jpg",
    onClickImgSrc: "https://i.pinimg.com/originals/e0/02/b3/e002b3fa22e928021eb883aea6092c80.jpg"
  }
  
];

export {architectureExamples};